<input *ngIf="this.getInputType()==='hidden'; else notHiddenFieldBlock"
  [attr.name]="name" type="hidden" [formControl]="control" />
<ng-template #notHiddenFieldBlock>
  <div class="widget form-group" [class.has-error]="control.invalid">
    <label [attr.for]="id" class="horizontal control-label">
      {{ schema.title }}
      <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
    </label>
    <div [class.input-group]="prefix || suffix">
      <div class="input-group-addon" *ngIf="prefix">{{ prefix }}</div>
      <input [name]="name" [attr.readonly]="(schema.widget.id!=='color') && schema.readOnly?true:null"
        class="text-widget textline-widget form-control" [attr.type]="this.getInputType()"
        [attr.id]="id"  [formControl]="control" [attr.placeholder]="schema.placeholder"
        [attr.maxLength]="schema.maxLength || null"
        [attr.minLength]="schema.minLength || null"
        [attr.disabled]="(schema.widget.id=='color' && schema.readOnly)?true:null" />
      <div class="input-group-addon" *ngIf="suffix">{{ suffix }}</div>
    </div>
    <input *ngIf="(schema.widget.id==='color' && schema.readOnly)" [attr.name]="name" type="hidden" [formControl]="control" />
    <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
    <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/string.widget.html